import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

const runtimeEnv = process.env.NODE_ENV === 'production' ? 'production' : 'local';
const stripePublicKey = (process.env.REACT_APP_STRIPE_PUBLIC_KEY || '').trim();
if (runtimeEnv !== 'production' && stripePublicKey.startsWith('pk_live')) {
  throw new Error('Unsafe Stripe config: local runtime cannot use a pk_live key.');
}
if (runtimeEnv === 'production' && stripePublicKey.startsWith('pk_test')) {
  throw new Error('Unsafe Stripe config: production runtime cannot use a pk_test key.');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
